// extracted by mini-css-extract-plugin
export var blue = "_1g-f";
export var brand = "_1g-b";
export var darkGrey = "_1g-e";
export var disabled = "_1g-4";
export var disabledSubtle = "_1g-5";
export var error = "_1g-6";
export var green = "_1g-g";
export var grey = "_1g-d";
export var icon = "_1g-0";
export var inherit = "_1g-a";
export var lightGrey = "_1g-c";
export var orange = "_1g-i";
export var pink = "_1g-k";
export var primary = "_1g-1";
export var purple = "_1g-l";
export var red = "_1g-j";
export var secondary = "_1g-2";
export var success = "_1g-9";
export var tertiary = "_1g-3";
export var warning = "_1g-7";
export var warningSecondary = "_1g-8";
export var white = "_1g-m";
export var yellow = "_1g-h";